import { render } from "./Board.vue?vue&type=template&id=1dbb9051&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=1dbb9051&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbb9051"]])

export default __exports__